import { render, staticRenderFns } from "./examine-list.vue?vue&type=template&id=a2787138&scoped=true&"
import script from "./examine-list.vue?vue&type=script&lang=js&"
export * from "./examine-list.vue?vue&type=script&lang=js&"
import style0 from "./examine-list.vue?vue&type=style&index=0&id=a2787138&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2787138",
  null
  
)

export default component.exports